// extracted by mini-css-extract-plugin
module.exports = {"account":"Account_account__2KfPv","content":"Account_content__21P6U"};